export default __webpack_public_path__ + "../img/b236b60e743bc85d920855698bba5957.png";